/**
 * Mock handlers for users service
 * Simulates backend API responses with in-memory state persistence
 */

import {
  getCurrentUserState,
} from '../data/users';
import { getUsersState } from '../data/tasks'; // Re-use task users for assignable users
import { getRandomDelay } from '../config';

/**
 * Simulate async delay for realistic network behavior
 * @param {number} ms - Milliseconds to delay
 * @returns {Promise}
 */
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// ============================================================
// USER OPERATIONS
// ============================================================

/**
 * Mock: GET /api/accounts/users/me/
 * Returns the current authenticated user
 * @returns {Promise<{data: Object}>}
 */
export const mockGetCurrentUser = async () => {
  await delay(getRandomDelay());
  return { data: getCurrentUserState() };
};

/**
 * Mock: GET /api/accounts/users/assignable/
 * Returns users that can be assigned to tasks (same tenant)
 * @returns {Promise<{data: Array}>}
 */
export const mockGetAssignableUsers = async () => {
  await delay(getRandomDelay());
  // Re-use the users from tasks mock data
  return { data: getUsersState() };
};

// ============================================================
// EXPORT ALL HANDLERS
// ============================================================

export default {
  mockGetCurrentUser,
  mockGetAssignableUsers,
};
